<template>
  <div class="extension__form">
    <standard-form :fields="fields" :object="object"></standard-form>

    <div class="builder">
      <div class="row">
        <div class="col">
          <div class="builder__row" v-for="(row, rowindex) in structure" :key="`structure-row-${rowindex}`">
            <div class="builder__col" v-for="(col, colindex) in row" :key="`structure-col-${colindex}`">
              <draggable v-model="col.fields" class="drag__area" @end="onFieldsChange" :options="{group:'fields'}">
                <div v-for="(element, elementindex) in col.fields" :key="`${elementindex}-${element.key}`" class="builder__field">{{element.label}}</div>
              </draggable>
              <div class="float-right builder__col__controls">
                <button type="button" class="btn btn-default" @click="removeCol(rowindex, colindex)">
                  <font-awesome-icon icon="minus-square" />
                </button>
                <button type="button" class="btn btn-default" @click="addCol(rowindex)">
                  <font-awesome-icon icon="plus-square" />
                </button>
              </div>
            </div>
            <div class="builder__row__controls">
              <button type="button" class="btn btn-default" @click="removeRow(rowindex)">
                <font-awesome-icon icon="minus-square" />
              </button>
            </div>
          </div>
          <div class="builder__controls">
            <button type="button" class="btn btn-default" @click="addRow">
              <font-awesome-icon icon="plus-square" />
            </button>
          </div>
        </div>
        <div class="col col--fields">
          <draggable v-model="availableFields" class="drag__area" @end="onFieldsChange" :options="{group:'fields'}">
            <div v-for="(element, elementindex) in availableFields" :key="`${elementindex}-${element.key}`" class="builder__field">{{element.label}}</div>
          </draggable>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import StandardForm from '@/components/StandardForm';
import Field from '@/components/Field';
import draggable from 'vuedraggable';

export default {
  props: ['object', 'fields'],
  components: {
    Field,
    StandardForm,
    draggable,
  },
  data() {
    return {
      dummy: {},
      availableFields: [],
    };
  },
  computed: {
    objectType() {
      return this.object.object_type;
    },
    fieldsForForm() {
      if (!this.objectType) {
        return [];
      }
      return this.$store.getters['fields/getTypeFields'](this.objectType);
    },
    structure: {
      get() {
        if (this.object.structure) {
          return this.object.structure;
        }
        return [
          [
            {
              fields: [],
            },
          ],
        ];
      },
      set(value) {
        this.$emit('structure', value);
      },
    },
  },
  methods: {
    onFieldsChange() {
      this.$emit('structure', this.object.structure);
    },
    addRow() {
      const current = JSON.parse(JSON.stringify(this.structure));
      current.push([{ fields: [] }]);
      this.structure = current;
    },
    removeRow(rowindex) {
      const current = JSON.parse(JSON.stringify(this.structure));
      current.splice(rowindex, 1);
      this.structure = current;
    },
    addCol(index) {
      const current = JSON.parse(JSON.stringify(this.structure));
      current[index].push({ fields: [] });
      this.structure = current;
    },
    removeCol(rowindex, colindex) {
      const current = JSON.parse(JSON.stringify(this.structure));
      current[rowindex].splice(colindex, 1);
      if (current[rowindex].length === 0) {
        current.splice(rowindex, 1);
      }
      this.structure = current;
    },
  },
  created() {
    this.$store.dispatch('fields/get');
  },
  watch: {
    fieldsForForm(value) {
      this.availableFields = value;
    },
  },
};
</script>

<style lang="scss">
.builder__row {
  border: 1px solid $border;
  border-radius: $btn-border-radius;
  display: flex;
  align-items: center;
}

.builder__row__controls {
  max-width: 70px;
  padding: 10px;
}

.builder__controls {
  padding: 10px;
  text-align: center;
}

.builder__col {
  flex: 1;
  overflow: hidden;
  padding: 10px;
  display: flex;
  align-items: center;
}

.builder__field {
  border: 1px solid $border;
  padding: 10px;
  cursor: move;
  margin-bottom: 2px;
  font-size: 0.75em;
}

.col--fields {
  max-width: 25%;
}

.drag__area {
  flex: 1;
  min-height: 40px;
}

.builder__col__controls {
  flex: 1;
  max-width: 110px;
  padding-left: 10px;
}
</style>
